interface LogoProps {
  className?: string;
  color?: string;
}

export function Logo({ className = "h-8", color = "currentColor" }: LogoProps) {
  return (
    <svg
      className={className}
      viewBox="430 430 1510 220"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="leboncoinche"
    >
      <defs>
        <clipPath id="final-e-clip">
          <rect x="1775" y="430" width="115" height="250" />
        </clipPath>
      </defs>
      <g>
        {/* e with swoosh (the signature leboncoin "e") */}
        <path
          d="M599.72,584.51c-4.9,9.39-17.15,20.65-32.14,20.65c-8.47,0-13.42-3.66-16.92-6.7l66.43-47.64
          c-7.71-25.16-26.22-45.21-60.71-45.21c-39.75,0-58.66,33.03-58.66,59.57c0,11.25,2.18,21.54,6.03,30.59
          c-8.53,4.65-15.08,8.13-21.09,8.13c-11.15,0-16.42-6.53-16.42-18.71l-0.01-119.97c0-12.72-8.48-20.71-18.71-20.7
          c-10.23,0-18.71,7.99-18.71,20.71l0.01,123.17c0,28.31,19.86,47.13,48.02,47.13c13.92,0,27.96-4.73,44.28-15.56
          c11.47,10.08,26.21,15.83,42.03,15.83c32.41,0,51.83-14.24,61.28-33.46L599.72,584.51z M556.38,535.58
          c12.43,0,16.95,7.49,19.21,10.88l-41.64,31c-1.49-3.86-2.75-10.02-2.75-14.19C531.2,544.28,544.54,535.58,556.38,535.58z"
        />
        {/* b */}
        <path
          d="M697.44,603.74c-16.77,0-27.04-13.27-27.04-33.05s10.26-33.05,27.04-33.05s27.04,13.27,27.04,33.05
          S714.21,603.74,697.44,603.74 M709.96,505.6c-15.27,0-28.54,6.26-39.06,19.78h-0.5v-59.84c0-12.77-8.51-20.78-18.78-20.78
          c-10.26,0-18.78,8.01-18.78,20.78v167.74h35.05v-19.03h0.5c8.51,13.52,23.03,21.53,40.31,21.53
          c32.3,0,54.33-27.79,54.33-65.59C763.03,533.14,742,505.6,709.96,505.6"
        />
        {/* o */}
        <path
          d="M839.14,603.74c-16.77,0-27.04-13.27-27.04-33.05s10.26-33.05,27.04-33.05c16.77,0,27.04,13.27,27.04,33.05
          S855.91,603.74,839.14,603.74 M839.14,635.79c39.56,0,65.09-27.04,65.09-65.09c0-38.05-25.54-65.09-65.09-65.09
          c-39.56,0-65.09,27.04-65.09,65.09C774.05,608.75,799.58,635.79,839.14,635.79"
        />
        {/* n */}
        <path
          d="M919.26,633.28V525.13c0-12.27,8.01-19.53,17.53-19.53c9.51,0,17.53,7.26,17.53,19.53v4.76h0.5
          c9.51-14.77,24.03-24.29,42.56-24.29c26.04,0,40.06,18.53,40.06,46.57v81.12h-37.55v-70.6c0-16.52-7.76-22.03-17.53-22.03
          c-14.52,0-25.54,12.27-25.54,38.31v54.33H919.26z"
        />
        {/* c */}
        <path
          d="M1089.5,570.69c0,20.53,10.01,32.55,26.29,32.55c10.77,0,18.78-5.26,22.78-12.52h0.5l27.29,17.53
          c-9.51,18.53-29.29,27.54-51.82,27.54c-39.06,0-63.09-27.04-63.09-65.09c0-38.05,24.03-65.09,63.09-65.09
          c22.53,0,42.31,9.01,51.82,27.54l-27.29,17.53h-0.5c-4.01-7.26-12.02-12.52-22.78-12.52
          C1099.51,538.15,1089.5,550.16,1089.5,570.69"
        />
        {/* o */}
        <path
          d="M1236.46,603.74c-16.77,0-27.04-13.27-27.04-33.05s10.26-33.05,27.04-33.05c16.77,0,27.04,13.27,27.04,33.05
          S1253.23,603.74,1236.46,603.74 M1236.46,635.79c39.56,0,65.09-27.04,65.09-65.09c0-38.05-25.54-65.09-65.09-65.09
          s-65.09,27.04-65.09,65.09C1171.36,608.75,1196.9,635.79,1236.46,635.79"
        />
        {/* i */}
        <path
          d="M1336.1,505.6c-10.26,0-18.78,8.01-18.78,20.78v106.9h37.55v-106.9C1354.88,513.61,1346.36,505.6,1336.1,505.6
          M1336.1,485.82c12.77,0,22.78-10.52,22.78-22.78c0-12.27-10.01-22.78-22.78-22.78c-13.02,0-23.03,10.52-23.03,22.78
          C1313.07,476.06,1323.58,485.82,1336.1,485.82"
        />
        {/* n */}
        <path
          d="M1375.4,633.28V525.13c0-12.27,8.01-19.53,17.53-19.53c9.51,0,17.53,7.26,17.53,19.53v4.76h0.5
          c9.51-14.77,24.03-24.29,42.56-24.29c26.04,0,40.06,18.53,40.06,46.57v81.12h-37.55v-70.6c0-16.52-7.76-22.03-17.53-22.03
          c-14.52,0-25.54,12.27-25.54,38.31v54.33H1375.4z"
        />
        {/* c - extending with "che" */}
        <path
          d="M1547.5,570.69c0,20.53,10.01,32.55,26.29,32.55c10.77,0,18.78-5.26,22.78-12.52h0.5l27.29,17.53
          c-9.51,18.53-29.29,27.54-51.82,27.54c-39.06,0-63.09-27.04-63.09-65.09c0-38.05,24.03-65.09,63.09-65.09
          c22.53,0,42.31,9.01,51.82,27.54l-27.29,17.53h-0.5c-4.01-7.26-12.02-12.52-22.78-12.52
          C1557.51,538.15,1547.5,550.16,1547.5,570.69"
        />
        {/* h */}
        <path
          d="M1640.4,633.28V465.54c0-12.77,8.51-20.78,18.78-20.78c10.26,0,18.78,8.01,18.78,20.78v59.84h0.5
          c10.52-13.52,23.78-19.78,39.06-19.78c26.04,0,40.06,18.53,40.06,46.57v81.12h-37.55v-70.6c0-16.52-7.76-22.03-17.53-22.03
          c-14.52,0-25.54,12.27-25.54,38.31v54.33H1640.4z"
        />
        {/* e: reuse the swoosh "le" path, clipped to show only the "e" bowl */}
        <g clipPath="url(#final-e-clip)">
          <g transform="translate(1278,0)">
            <path
              d="M599.72,584.51c-4.9,9.39-17.15,20.65-32.14,20.65c-8.47,0-13.42-3.66-16.92-6.7l66.43-47.64
              c-7.71-25.16-26.22-45.21-60.71-45.21c-39.75,0-58.66,33.03-58.66,59.57c0,11.25,2.18,21.54,6.03,30.59
              c-8.53,4.65-15.08,8.13-21.09,8.13c-11.15,0-16.42-6.53-16.42-18.71l-0.01-119.97c0-12.72-8.48-20.71-18.71-20.7
              c-10.23,0-18.71,7.99-18.71,20.71l0.01,123.17c0,28.31,19.86,47.13,48.02,47.13c13.92,0,27.96-4.73,44.28-15.56
              c11.47,10.08,26.21,15.83,42.03,15.83c32.41,0,51.83-14.24,61.28-33.46L599.72,584.51z M556.38,535.58
              c12.43,0,16.95,7.49,19.21,10.88l-41.64,31c-1.49-3.86-2.75-10.02-2.75-14.19C531.2,544.28,544.54,535.58,556.38,535.58z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export function LogoIcon({
  className = "h-8 w-8",
  color = "currentColor",
}: LogoProps) {
  return (
    <svg
      className={className}
      viewBox="460 440 180 230"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="leboncoinche"
    >
      {/* The signature "le" swoosh mark from the original logo */}
      <path
        d="M599.72,584.51c-4.9,9.39-17.15,20.65-32.14,20.65c-8.47,0-13.42-3.66-16.92-6.7l66.43-47.64
        c-7.71-25.16-26.22-45.21-60.71-45.21c-39.75,0-58.66,33.03-58.66,59.57c0,11.25,2.18,21.54,6.03,30.59
        c-8.53,4.65-15.08,8.13-21.09,8.13c-11.15,0-16.42-6.53-16.42-18.71l-0.01-119.97c0-12.72-8.48-20.71-18.71-20.7
        c-10.23,0-18.71,7.99-18.71,20.71l0.01,123.17c0,28.31,19.86,47.13,48.02,47.13c13.92,0,27.96-4.73,44.28-15.56
        c11.47,10.08,26.21,15.83,42.03,15.83c32.41,0,51.83-14.24,61.28-33.46L599.72,584.51z M556.38,535.58
        c12.43,0,16.95,7.49,19.21,10.88l-41.64,31c-1.49-3.86-2.75-10.02-2.75-14.19C531.2,544.28,544.54,535.58,556.38,535.58z"
      />
    </svg>
  );
}
